import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { SummaryComponent } from './summary.component';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('registration.summary', {
            url: '/summary',
            ncyBreadcrumb: {
                label: 'Riepilogo',
                parent: 'registration.contract-step2'
            },
            data: {
                authorisationLevel: 0,
                pageTitle: 'Registration Riepilogo'
            },
            'views': {
                'multiContentRegistration': {
                    template: '<summary flex="100"></summary>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const SummaryModule: string = ng
    .module('summary', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('summary', SummaryComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/summary/summary.module.ts